import { GENERAL_SET_GRAPH_DATA, GENERAL_SET_PIE_DATA, GENERAL_TRASACTION, PIE_DATA_EMPTY, RESET_PORTFOLIO, RESET_DATA, RESET_GENERAL_PORT, } from "./types";
const initialState = {
    assets: {
        assets_cat_data: null,
        assets_cat_pie: null,
        assets_total: null,
    },
    incomexp: {
        income_data: null,
        income_pie: null,
        income_total: null,
        income_trans_data: null,
        expense_data: null,
        expense_pie: null,
        expense_total: null,
        expense_trans_data: null,
        cashflow_data: null,
        cashflow_graph: null,
        cashflow_total: null,
    },
    liability: {
        credit_data: null,
        credit_pie: null,
        credit_total: null,
    },
    networth: {
        networth_data: null,
        networth_graph: null,
        networth_total: null,
    },
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GENERAL_SET_PIE_DATA: {
            return {
                ...state,
                [action.payload.screen]: {
                    ...state[action.payload.screen],
                    [`${action.payload.api_name}_data`]: action.payload.accord_data,
                    [`${action.payload.api_name}_pie`]: action.payload.pie_data,
                    [`${action.payload.api_name}_total`]: action.payload.total,
                },
            };
        }
        case GENERAL_SET_GRAPH_DATA:
            return {
                ...state,
                [action.payload.screen]: {
                    ...state[action.payload.screen],
                    [`${action.payload.api_name}_data`]: action.payload.accord_data,
                    [`${action.payload.api_name}_graph`]: action.payload.graph_data,
                    [`${action.payload.api_name}_total`]: action.payload.total,
                },
            };
        case GENERAL_TRASACTION:
            return {
                ...state,
                [action.payload.screen]: {
                    ...state[action.payload.screen],
                    [`${action.payload.api_name}_trans_data`]: action.payload.trans_data,
                },
            };
        case PIE_DATA_EMPTY:
            return {
                ...state,
                [action.payload.screen]: {
                    ...state[action.payload.screen],
                    [`${action.payload.api}_data`]: [],
                    [`${action.payload.api}_pie`]: [],
                    [`${action.payload.api}_graph`]: [],
                    [`${action.payload.api}_total`]: null,
                },
            };
        case RESET_PORTFOLIO: {
            return {
                ...initialState,
                assets: {
                    ...initialState.assets,
                },
                incomexp: {
                    ...initialState.incomexp,
                },
                liability: {
                    ...initialState.liability,
                },
                networth: {
                    ...initialState.networth,
                },
            };
        }
        case RESET_GENERAL_PORT: {
            return {
                ...state,
                [action.payload.screen]: {
                    ...initialState[action.payload.screen],
                },
            };
        }
        // Remove this, incorrect method to update state.
        case RESET_DATA:
            return {
                ...state,
                ...initialState,
            };
        default:
            return state;
    }
};
